import { useContext } from 'react'
import { VideosUploaderContext, VideosUploaderContextProps } from '../providers/videos-uploader-provider'

export const useVideosUploader = (): VideosUploaderContextProps => {
  return useContext(VideosUploaderContext)
}
